export const PNC = 'PNC';

export const orderOptions = [
  {'text': 'S', 'value': 'S'},
  {'text': 'N', 'value': 'N'},
];

export const inputFields = [
  {'name': 'PNC', 'width': '82px', 'required': true, 'maxLength': '7', 'englishName': 'partNumberCode'},
  {'name': 'Nombre', 'width': '80px', 'required': true, 'maxLength': '50', 'englishName': 'name'},
  {'name': 'Desc. Inglés', 'width': '80px', 'required': false, 'maxLength': '50',
    'englishName': 'englishDescription'},
  {'name': 'Descripción General', 'width': '200px', 'required': false, 'maxLength': '80',
    'englishName': 'generalDescription'},
  {'name': 'Grupo', 'width': '100px', 'required': true, 'maxLength': '40', 'englishName': 'group'},
  {'name': 'Uso', 'width': '100px', 'required': false, 'maxLength': '80', 'englishName': 'use'},
  {'name': 'Presentación/Empaque', 'width': '150px', 'required': false, 'maxLength': '40',
    'englishName': 'presentation'},
  {'name': 'Composición', 'width': '100px', 'required': false, 'maxLength': '100', 'englishName': 'composition'},
  {'name': 'Lado', 'width': '95px', 'required': false, 'maxLength': '40', 'englishName': 'side'},
  {'name': 'Vehículo', 'width': '80px', 'required': true, 'maxLength': '20', 'englishName': 'vehicle'},
];

export const dropdownFields = [
  {'name': 'Pedido', 'width': '5px', 'englishName': 'order'},
];

export const controlFields = [{'name': 'Acciones', 'width': '1px'}];
